import axios from 'axios';

export const getBankTransactionsApi = async ({
  customerId,
  startDate,
  endDate,
  accountIds = [],
  page = 1,
  pageSize = 50,
}) => {
  const params = {
    startDate,
    endDate,
    page,
    pageSize,
  };

  // Only include accountIds if provided
  if (accountIds && accountIds.length > 0) {
    accountIds.forEach((id, index) => {
      params[`accountIds[${index}]`] = id;
    });
  }

  const response = await axios.get(
    `/admin/customer/${customerId}/bank-transactions`,
    { params }
  );
  return response.data;
};

/**
 * Fetches accounting data (Profit & Loss and Balance Sheet) for a customer
 * @param {Object} params - Request parameters
 * @param {string} params.customerId - Customer ID to fetch data for
 * @param {string} [params.endDate] - End date in YYYY-MM-DD format (defaults to current month end if not provided)
 * @param {number} [params.compareMonths=1] - Number of months to compare (1-12, will be clamped to valid range)
 * @returns {Promise<Object>} Accounting data response containing P&L and Balance Sheet sections with month-over-month comparisons
 * @throws {Error} If the API request fails
 * @example
 * const data = await getAccountingDataApi({
 *   customerId: '12345',
 *   endDate: '2026-01-31',
 *   compareMonths: 6
 * });
 */
export const getAccountingDataApi = async ({
  customerId,
  endDate,
  compareMonths = 1,
}) => {
  const params = { compareMonths: Math.min(12, Math.max(1, compareMonths)) };
  if (endDate) params.endDate = endDate;
  const response = await axios.get(
    `/admin/customer/${customerId}/accounting`,
    { params }
  );
  return response.data;
};
